import HomeCanilParra from './HomeCanilParra';

export default function App() {
  return <HomeCanilParra />;
}